// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DiagnosisSearchModelResponse {
    static getAttributeTypeMap() {
        return DiagnosisSearchModelResponse.attributeTypeMap;
    }
}
DiagnosisSearchModelResponse.discriminator = undefined;
DiagnosisSearchModelResponse.additionalProperties = false;
DiagnosisSearchModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "DiagnosisSearchResponseModel"
    },
];
//# sourceMappingURL=diagnosisSearchModelResponse.js.map